export const datatypeMap = {
  // Uppercase keys (legacy)
  TEXT: "text",
  NUMBER: "number",
  BOOLEAN: "checkbox",
  DATE: "date",
  DATETIME: "date",
  LIST: "list",
  // Lowercase keys (from schema API)
  text: "text",
  textarea: "text",
  number: "number",
  boolean: "checkbox",
  date: "date",
  datetime: "date", // CSVBox built-in date type
  select: "list",
  multi_select: "text", // CSVBox doesn't support multi-select in list, use text for comma-separated values
  user: "text",
  email: "email",
  url: "text",
  phone_number: "text", // Use text type - CSVBox's phone_number type is too restrictive
  phone: "text", // Use text type - CSVBox's phone_number type is too restrictive
  domain: "text",
  list: "list" 
};
